export enum Languages {
  ES = 'es',
  EN = 'en'
}
